import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, addDoc } from "firebase/firestore";
import { auth, db, storage, functions,messaging } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import WarningAmber from '@mui/icons-material/WarningAmber';
import Icon from '@mui/material/Icon';
import { Select, MenuItem, FormControl, InputLabel, TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


// import { functions } from '../../../firebase'


import { httpsCallable, getFunctions } from 'firebase/functions';


const New = () => {

  const [file, setFile ] = useState("")
  const [title, setTitle] = useState("")
  const [body, setBody] = useState("")
  const [isloading, setIsloading ] = useState(false)
  const [titleError, setTitleError] = useState("")
  const [bodyError, setBodyError] = useState("")

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }

  



  //  useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Platinum"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push(doc.data().userId)
  //       })
  //       setPlatinumList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  //   useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Premium"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push(doc.data().userId)
  //       })
  //       setPremiumList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  //   useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Standard"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push( doc.data().userId )
  //       })
  //       setStandardList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  // const handleChange = (event) => {
  //   setPlan(event.target.value);
  // };

  //  const handleChangeIcon = (event) => {
  //   setIcon(event.target.value);
  // };

  // const handleChangeIconColor = (event) => {
  //   setIconcolor(event.target.value);
  // };


  const handleSingleNotification = async(e) => {

    e.preventDefault()

    if(title === "") {

      return setTitleError('title is required')
      
    }

     if(body === "") {

      return setBodyError('body is required')
      
    }

      setIsloading(true)

      // try {

      //   const docRef = await addDoc(collection(db, 'announcements'), {
          
      //     title: title,
      //     message: body,
      //     timestamp: today,

      //     // Data object for navigation

      //     // navigationData: {
      //     //   screen: 'Notification', 
      //     //   params: { id: docRef.id } 
      //     // }
          
      //   });


      //     setIsloading(false)
          
      //     alert("Announcement has been sent successfully!!!")

      //     navigate('/group')

      //     console.log("Document written with ID: ", docRef.id);

      // } catch (e) {

      //   console.error("Error adding document: ", e);

      // }finally{

      //      setIsloading(false)

      // }

      try {

          const docRef = await addDoc(collection(db, 'announcements'), {
          
          title: title,
          body: body,
          timestamp: today,
          
        });

          const id = docRef.id

          const sendBroadcastNotification = httpsCallable(functions, 'sendBroadcastNotification');

          const result = await sendBroadcastNotification({title: title, body: body, announcementId: id});


          if(result.data.success === true){

            setIsloading(false)
          
            alert(result.data.message)

            navigate('/group')

          }

          // alert(result.data.messageId)

          // console.log(result.data.messageId);

          setIsloading(false)

      } catch (error) {

          console.error('Error requesting:', error);

      }finally{

           setIsloading(false)

      }

      
       
  }


  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Group Notification</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/group"
            >
              Notification List
            </Link>
            <Typography color="green">New Notification</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
          <div className='right'>
            <div className='form'>

                  
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'50%', marginBottom:0, marginRight:0}}>
                    <TextField
                      id="title"
                      onChange={(e) => setTitle(e.target.value)}
                      value = {title}
                      placeholder="Enter Title"
                      style={{width:'100%'}}

                    />

                    {titleError &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {titleError}</p>
                    }
                    
                  </div>

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'50%', marginBottom:0, marginRight:0}}>

                    <TextField
                      id="message" 
                      value={body}
                      multiline
                      minRows={3}
                      maxRows={10}
                      placeholder="Enter Message"
                      style={{width:'100%'}}
                      onChange={(e) => setBody(e.target.value)}
                    />

                     {bodyError &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {bodyError}</p>
                    }

                  </div>


                  <Button onClick={handleSingleNotification} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? '...loading' : 'Send Notification'}</Button>


            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New
